import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--tab"
export default class extends Controller {
  static targets = ["tab", "tabBody"];
  connect() {}

  toggle(e) {
    const value = e.currentTarget.dataset["resumin-TabTargetContentValue"];
    this.tabTargets.forEach((target) => {
      target.classList.remove("is-active");
    });
    e.currentTarget.classList.add("is-active");

    this.tabBodyTargets.forEach((target) => {
      target.classList.replace("block", "hidden");
    });

    this.tabBodyTargets
      .find((target) => target.dataset["resumin-TabContentValue"] === value)
      .classList.replace("hidden", "block");
  }
}
